A physical location with a persistent identifier.
